import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://localhost:7158";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

// Attach admin token if present
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
        config.headers["X-Admin-Token"] = token;
    }

    const customerToken = localStorage.getItem("customer_token");
    if (customerToken) {
        config.headers.Authorization = `Bearer ${customerToken}`;
    }

    return config;
});

// Turn a stored photo_url into a full display URL
export function resolvePhotoUrl(photo_url) {
    if (!photo_url) return "";
    if (photo_url.startsWith("http")) return photo_url;
    if (photo_url.startsWith("/api/")) return `${BACKEND_URL}${photo_url}`;
    return photo_url;
}
